import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/auth/useAuth';
import { fetchWorkflows } from '@/services/logicAppsApi';
import { useAppStore } from '@/stores/appStore';

export const useWorkflows = () => {
  const { isAuthenticated, getOttoToken } = useAuth();
  const { selectedApp, selectedProject } = useAppStore();

  return useQuery({
    queryKey: ['workflows', selectedProject?.toLowerCase(), selectedApp?.name?.toLowerCase()],
    queryFn: async () => {
      if (!selectedApp || !selectedProject) {
        return [];
      }
      return fetchWorkflows({
        projectName: selectedProject ?? '',
        appName: selectedApp?.name ?? '',
        getToken: getOttoToken,
      });
    },
    // In local mode, hostName may be empty initially but fetchWorkflows
    // short-circuits to localFetch anyway, so we only require appId
    enabled: isAuthenticated && !!selectedApp && !!selectedProject,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
